import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/voices/')({
  component: () => (
    <EmptyState
      icon="mic"
      title="Выбери голос"
      description="Слева — каталог голосов клонирования"
    />
  ),
})
